import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../contexts/authContext";
import UserService from "../../services/userService";

import userIcon from "../../assets/img/user_icon.png";
import logo from '../../assets/img/logo.png';

export const Header = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { logout } = UserService();

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const logoutHandler = () => {
     logout();
     setIsMenuOpen(false);
  }

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return(
    <nav className="flex items-center justify-between bg-lightGray border-b border-secondary h-14 w-full relative z-30">
      <div className="flex items-center pl-6">
        <img src={logo} className="h-4 w-auto object-contain" alt="Logo" />
      </div>

      <div className="flex items-center gap-3 pr-6">
        <div className="hidden md:flex flex-col items-end leading-tight">
            <span className="text-base font-semibold text-darkGray">
                {user?.email} ({user?.role})
            </span>

            <span onClick={logoutHandler}
            className="text-sm text-darkGray cursor-pointer hover:underline">
                {t('HEADER.LOGOUT')}
            </span>
        </div>
        <img src={userIcon}
            onClick={toggleMenu} className="h-8 w-auto object-contain cursor-pointer md:cursor-default" alt="userIcon"
        />
        {isMenuOpen && (
            <>
                <div
                    className="fixed inset-0 z-40 bg-transparent"
                    onClick={() => setIsMenuOpen(false)}
                ></div>

                <div className="absolute top-14 right-4 w-64 bg-white border border-secondary shadow-xl rounded-md z-50 md:hidden flex flex-col p-4">
                    <div className="border-b border-secondary pb-2 mb-2">
                        <p className="text-sm text-darkGray uppercase font-semibold mb-1"> {t('HEADER.USER')}</p>
                        <p className="text-sm text-darkGray font-semibold truncate" title={user?.email}>
                            {user?.email}
                        </p>
                        <p className="text-xs text-mediumGray">({user?.role})</p>
                    </div>
                    <button
                        onClick={logoutHandler}
                        className="text-left text-sm text-darkGray cursor-pointer hover:underline"
                    >
                        {t('HEADER.LOGOUT')}
                    </button>
                </div>
            </>
        )}

      </div>
    </nav>
  );
};